import React from 'react';
import {Container} from './styles';

const Footer: React.FC = () => {
  return <Container>Literaverso - Todos os direitos reservados 2023</Container>;
}

export default Footer;